// Copied from https://github.com/ng-web-apis/common/blob/master/projects/common/src/tokens/window.ts
// license allows copying portion of code with attribution: https://github.com/ng-web-apis/common/blob/master/LICENSE

import { inject, InjectionToken, DOCUMENT } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('An abstraction over global window object', {
  factory: () => {
    const { defaultView } = inject(DOCUMENT);

    if (!defaultView) {
      throw new Error('Window is not available');
    }

    return defaultView;
  },
});
